export default ({ $axios, redirect, store, route }) => {
    // request
    $axios.onRequest((config) => {
        console.log('request')
        console.log(config)
    })
    // response
    $axios.onResponse((config) => {
        console.log('response')
        console.log(config)
    })
    // error
    $axios.onError((e) => {
        console.log('error')
        console.log(e.response)
    })
}